import { r as s, h as t } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const e = ".sc-stop-icon-h{display:flex}", i = e, r = class {
  constructor(o) {
    s(this, o), this.width = "15", this.height = "15";
  }
  render() {
    return t("svg", { key: "523d5cb945c10c5860b83117bad5951406fa40b7", width: this.width, height: this.height, viewBox: "0 0 24 24", fill: "auto", xmlns: "http://www.w3.org/2000/svg" }, t("path", { key: "de92fe3f9ff16ed4935ab04eb89f0cb07480302e", d: "M4 4H20V20H4V4Z", stroke: "auto", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }));
  }
};
r.style = i;
export {
  r as stop_icon
};
